import { getPinMenuLabel } from "@design-system/ViewToolbar/PinMenu";

/**
 * Pinning moves a column's row to another section, which remounts it, so the
 * pin menu's trigger that held focus is gone. Focus the new row's trigger
 * once the menu has closed. It's found by the label `PinMenu` gives it.
 */
export const focusPinMenu = ({
    list,
    name,
}: {
    list: HTMLElement | null;
    name: string;
}) => {
    const label = getPinMenuLabel(name);
    requestAnimationFrame(() => {
        const trigger = Array.from(list?.querySelectorAll("button") ?? []).find(
            (button) => button.getAttribute("aria-label") === label,
        );
        trigger?.focus();
    });
};
